export enum HouseKeepingStatus {
  Clean = "Clean",
  Dirty = "Dirty",
  OOO = "OOO",
  OOS = "OOS",
  ShowRoom= "ShowRoom",
  Accepted = "Accepted"
}